<template lang="html">
  <div class="form-control"
    :class="fieldClasses">
    <div class="field-wrapper">
      <label class="form-label">{{label}}</label>
      <Tooltip
          v-if="tooltip"
          :tooltipText="tooltip"/>
      <div class="wrapper">
        <div class="checkboxes is-block" :class="getRowClass">
          <template v-for="(option, index) in options">
            <div class="checkbox is-switch" :class="getColumnClass">
              <input
              v-model="model"
              type="checkbox"
              :name="name"
              :id="name + '_' + option.id"
              :value="option.id">
              <label
              :for="name + '_' + option.id">{{option.name}}</label>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import Tooltip from '@/components/Tooltip.vue';

export default {
  name: 'VqCheckboxes',
  props: {
    label: String,
    name: String,
    fieldClasses: String,
    options: Array,
    value: Array,
    tooltip: String,
    columns: {
      type: Number,
      default: 1,
      required: false,
    },
  },
  components: {
    Tooltip,
  },
  mounted() {
  },
  data() {
    return {
    };
  },
  methods: {

  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    getRowClass() {
      return this.columns > 1 ? 'row' : 'group';
    },
    getColumnClass() {
      return `col-tab-${12 / this.columns}`;
    },
  },
  watch: {
  },
};
</script>

<style scoped lang="scss">
</style>
